import {StandardFiles} from '../../models/standard-files.model';
import {StandardDocumentContext} from '../../services/view-docx.service';

export const STANDARD_READ_QUERY = 'readDocument';
export const STANDARD_READ_RUSSIAN = 'Ru';
export const STANDARD_READ_ENGLISH = 'En';

export function standardReaderDocument(standard: StandardFiles, language: string): StandardDocumentContext {
  if (!standard || (language !== STANDARD_READ_RUSSIAN && language !== STANDARD_READ_ENGLISH)) { return null; }
  const english = language === STANDARD_READ_ENGLISH;
  return documentForLanguage(standard, english) || documentForLanguage(standard, !english);
}

function documentForLanguage(standard: StandardFiles, english: boolean): StandardDocumentContext {
  const fileLink = english ? standard.enFileLink : standard.ruFileLink;
  const fileId = english ? standard.enDoc : standard.ruDoc;
  if (fileLink) { return {fileLink, fileId: null, standardId: null}; }
  return fileId ? {fileId, standardId: standard.id, fileLink: null} : null;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-standards/standard-reader-document.ts